<ul class="thead text">
    <li class="th-no">{{ "operation.table.header.number" | translate }}</li>
    <li>User</li>
    <li class="fill-half">{{ "alarm.table.header.value" | translate }}</li>
    <li>{{ "operation.table.header.Item" | translate }}</li>
    <li>{{ "alarm.table.header.status" | translate }}</li>
    <li class="center">{{ "operation.table.header.action" | translate }}</li>
    <li class="icon-flex th-date">
        <div>{{ "operation.table.header.date" | translate }}</div>
        <div
            (click)="onOccurrenceTimeSortClicked()"
            class="icon sort"
            [ngClass]="sort"
        ></div>
    </li>
    <li
        class="fill-half"
        style="
            padding-left: 10px;
            display: flex;
            justify-content: end;
            gap: 12px;
        "
    >
        <mat-icon
            svgIcon="refresh"
            (click)="emitRefresh()"
            class="reset-btn"
        ></mat-icon>
        <img
            class="sort-btn"
            src="assets/icons/sort.svg"
            (click)="onOccurrenceTimeSortClicked()"
        />
    </li>
</ul>
